import calls from '@/backend/api-calls'

const state = () => ({
  productionSheet: null,
  selected: [],
  allSelected: false,
  loading: false
})

// getters
const getters = {
  itemIds: state => {
    return state.productionSheet.items.map(d => d.id);
  }
}

// actions
const actions = {
  getProductionSheet: ({commit}, productionSheetId) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.productionSheet.get(productionSheetId)
        .then(resp => {
          commit("setProductionSheet", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  updateProductionSheet: ({commit}, { productionSheetId, data }) => {
    return new Promise((resolve, reject) => {
      calls.productionSheet.put(productionSheetId, data)
        .then(resp => {
          commit("setProductionSheet", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Production sheet successfully updated'
          }, { root: true });
          
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  uploadImage: ({commit}, { productionSheetId, data }) => {
    return new Promise((resolve, reject) => {
      calls.productionSheet.attachImage(productionSheetId, data)
        .then(resp => {
          commit("setProductionSheet", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Attachment successfully changed'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addItem: ({commit}, item) => {
    return new Promise((resolve, reject) => {
      calls.productionSheetsItems.post(item).then(
        resp => {
          commit("insertItem", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Production sheet item successfully added'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateItem: ({commit}, { itemId, data }) => {
    return new Promise((resolve, reject) => {
      calls.productionSheetsItem.put(itemId, data).then(
        resp => {
          commit("insertUpdatedItem", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Production sheet item successfully updated'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteItem: ({commit}, itemId) => {
    return new Promise((resolve, reject) => {
      calls.productionSheetsItem.delete(itemId).then(
        resp => {
          commit("removeItem", itemId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Production sheet item successfully deleted'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.itemIds);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setProductionSheet(state, data) {
    state.productionSheet = data;
  },
  insertItem(state, item) {
    state.productionSheet.items.push(item)
  },
  insertUpdatedItem(state, updatedItem) {
    state.productionSheet.items.forEach((item, i) => {
      if (item.id == updatedItem.id) {
        state.productionSheet.items.splice(i, 1, updatedItem);
      }
    })
  },
  removeItem(state, itemId) {
    state.productionSheet.items.forEach((item, i) => {
      if (item.id == itemId) {
        state.productionSheet.items.splice(i, 1);
      }
    })

    let index = state.selected.indexOf(itemId);
    if (index != -1) {
      state.selected.splice(index, 1);
    }
  },
  selectAll(state, itemIds) {
    state.allSelected = true;
    itemIds.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length);
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}